(() => {
  const NOTE_CLASS = 'custom-cart-guest-checkout-note';
  const NOTE_TEXT = 'No account required — guest checkout available.';

  function addNote(checkoutButton) {
    const checkoutArea = checkoutButton.closest('.cart__ctas, form') || checkoutButton.parentElement;
    if (!checkoutArea || checkoutArea.previousElementSibling?.classList.contains(NOTE_CLASS)) return;

    const note = document.createElement('p');
    note.className = NOTE_CLASS;
    note.textContent = NOTE_TEXT;
    checkoutArea.insertAdjacentElement('beforebegin', note);
  }

  function initialize() {
    document
      .querySelectorAll('#checkout, #CartDrawer-Checkout, #cart-notification-form button[name="checkout"]')
      .forEach(addNote);
  }

  initialize();
  new MutationObserver(initialize).observe(document.body, { childList: true, subtree: true });
})();
